import React, { useEffect, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import { toast } from "react-toastify";
import { editModeOn, sanitizeInput, viewModeOn } from "../../utilFunctions";
import FileUpload from "../../utilsComponent/fileUpload";
import LoadingPage from "../../reusableComponents/loader/loadingPage";
import "../../dashboard/claimLitigation/litigation.scss";
import {
  createClaimLitigation,
  getLitigationLists,
  createLegalExpense,
  getLegalExpenses,
  updateFlag,
  fetchFlagDetails,
} from "./litigationApi";
import AsteriskSymbol from "../../reusableComponents/AsteriskSymbol";
import TabComponent from "../../reusableComponents/tab/TabComponent";
import {
  functionalities,
  REGEX,
  flagClaimsMaxLength,
  Litigationvalidtypes,
  LITIGATION,
  DATE_FORMAT,
} from "../../consts";
import NoDataFound from "../../utilsComponent/noDataFound";
import { Button, Modal, ModalBody, ModalFooter } from "react-bootstrap";
import { formatDocumentDetails } from "./helper";
import DocumentSliderModal from "../../utilsComponent/DocumentSliderModal";
import { format } from "date-fns";
import ViewMoreLess from "../../reusableComponents/ViewMoreLess";

const Litigation = (props) => {
  const { claimDetailCookie, roleDataCookie, getClaimDetails } = props;
  const [showRemarksDocs, setShowRemarksDocs] = useState(false);
  const [addedFiles, setAddedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [flagLitigation, setFlagLitigation] = useState(false);
  const [remarksInModal, setRemarksInModal] = useState("");
  const [litigationModal, setLitigationModal] = useState(false);
  const [previousFlagLitigation, setPreviousFlagLitigation] = useState(false);
  const [litigationList, setLitigationList] = useState([]);
  const [showAddLegalExpense, setShowAddLegalExpense] = useState(false);
  const [legalExpenseAmount, setLegalExpenseAmount] = useState("");
  const [expenseList, setExpenseList] = useState();
  const [showModal, setShowModal] = useState(false);
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [activeTab, setActiveTab] = useState(
    viewModeOn(functionalities.CLAIM_LITIGATION_SUBMISSION)
      ? "litigation"
      : viewModeOn(functionalities.CLAIM_LEGAL_EXPENSES_PAGE)
      ? "legalExpense"
      : ""
  ); // 'litigation' or 'legalExpense'
  const [rows, setRows] = useState([]);
  const [finalLitigationData, setFinalLitigationData] = useState([])
  const isLitigationFlagged = claimDetailCookie?.flags?.some(f => f.flagId === LITIGATION)

  useEffect(() => {
    if (viewModeOn(functionalities.CLAIM_LITIGATION_SUBMISSION)) {
      getLitigation();
    }
    if (viewModeOn(functionalities.CLAIM_LEGAL_EXPENSES_PAGE)) {
      getLegalExpense();
    }
  }, []);

  useEffect(() => {
    if (claimDetailCookie?.claimNo) {
      getLitigationDetails();
    }
  }, [claimDetailCookie?.claimNo]);

  const getLitigation = () => {
    setLoading(true);
    getLitigationLists(claimDetailCookie?.claimNo, setLoading)
      .then((data) => {
        setLitigationList(data);
      })
      .catch((error) => {
        console.error("Error fetching litigation list:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getLegalExpense = () => {
    setLoading(true);
    getLegalExpenses(claimDetailCookie?.claimNo, setLoading)
      .then((data) => {
        setExpenseList(data);
      })
      .catch((error) => {
        console.error("Error fetching litigation list:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const createLitigation = () => {
    if (!remarks.trim()) {
      toast.error("Please Enter Remarks.");
      return;
    }
    setLoading(true);
    const litigationData = {
      claimId: claimDetailCookie?.claimNo,
      userId: roleDataCookie?.userID,
      documentId: addedFiles.map((list) => list.id),
      remarks: remarks.trim(),
    };
    createClaimLitigation(litigationData, setLoading)
      .then((data) => {
        toast.success(data.message);
        getClaimDetails(claimDetailCookie.claimNo);
        clearRemarksDocs(); // Reuse the clear function
        // Fetch the updated litigation list
        getLitigationLists(claimDetailCookie.claimNo, setLoading)
          .then((updatedList) => {
            setLitigationList(updatedList);
          })
          .catch((error) => {
            console.error("Error fetching updated litigation list:", error);
          });
      })
      .catch((error) => {
        console.error("Error creating litigation:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const clearRemarksDocs = () => {
    setRemarks(""); // Clear remarks here as well
    setAddedFiles([]);
    setShowRemarksDocs(false);
  };

  const clearCreateLegalExpenses = () => {
    setRemarks("");
    setAddedFiles([]);
    setShowAddLegalExpense(false);
    setLegalExpenseAmount("");
  };

  const handleAddLegalExpenseClick = () => {
    if (
      claimDetailCookie.assignedTo === "Unassigned" ||
      !claimDetailCookie.assignedTo
    ) {
      toast.error("Please Assign Claims Handler.");
      return;
    }
    setShowAddLegalExpense(true);
  };

  const handleRemarksDocsClick = () => {
    if (
      claimDetailCookie.assignedTo === "Unassigned" ||
      !claimDetailCookie.assignedTo
    ) {
      toast.error("Please Assign Claims Handler.");
      return;
    }
    setShowRemarksDocs(true);
  };

  const handleCreateLegalExpense = () => {
    if (!legalExpenseAmount.trim() || !remarks.trim()) {
      toast.error(
        !legalExpenseAmount.trim()
          ? "Please Enter Legal Expense Amount."
          : "Please Enter Remarks."
      );
      return;
    }
    setLoading(true);
    const legalExpenses = {
      claimID: claimDetailCookie?.claimNo,
      amount: legalExpenseAmount.trim(),
      userId: roleDataCookie?.userID,
      documentId: addedFiles.map((list) => list.id),
      remarks: remarks.trim(),
    };

    createLegalExpense(legalExpenses, setLoading)
      .then((response) => {
        toast.success(
          response.message || "This claim has been flagged for legal review"
        );
        getClaimDetails(claimDetailCookie.claimNo);
        clearCreateLegalExpenses();
        getLegalExpenses(claimDetailCookie.claimNo, setLoading)
          .then((updatedList) => {
            setExpenseList(updatedList);
          })
          .catch((error) => {
            console.error("Error fetching updated legal expense list:", error);
          });
      })
      .catch((error) => {
        console.error("Error creating legal expense:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };
  const tabs = [
    {
      key: "litigation",
      label: "Claim Litigation",
      page: functionalities.CLAIM_LITIGATION_SUBMISSION,
    },
    {
      key: "legalExpense",
      label: "Legal Expenses",
      page: functionalities.CLAIM_LEGAL_EXPENSES_PAGE,
    },
  ];
  const filteredTabs = tabs.filter((tab) => viewModeOn(tab.page));

  useEffect(() => {
    if (activeTab) {
      setRemarks("");
      setAddedFiles([]);
      setLegalExpenseAmount("");
      setShowRemarksDocs(false);
      setShowAddLegalExpense(false);
    }
  }, [activeTab]);

  const getLitigationDetails = () => {
    fetchFlagDetails(claimDetailCookie?.claimNo, LITIGATION, setLoading)
      .then((data) => {
      setRows(data?.records)
      if (!data?.records?.length) {
        setFlagLitigation(false);
        setPreviousFlagLitigation(false);
      } else {
        const latestActivity = data?.records[0]?.activityName || "";
        if (latestActivity === "Litigation Unflagged") {
          setFlagLitigation(false);
          setPreviousFlagLitigation(true);
        } else if (latestActivity === "Litigation Flagged" || latestActivity === "Litigation Re-flagged") {
          setFlagLitigation(true);
          setPreviousFlagLitigation(true);
        }
      }
      })
      .catch((error) => {
        console.error("Error fetching litigation details:", error);
        setFlagLitigation(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleFlagLitigation = () => {
    const isFlagLitigationChecked = !flagLitigation;
    setPreviousFlagLitigation(flagLitigation);
    setFlagLitigation(isFlagLitigationChecked);
    setLitigationModal(true);
  };
  const submitLitigation = async () => {
    if (
      claimDetailCookie.assignedTo === "Unassigned" ||
      !claimDetailCookie.assignedTo
    ) {
      toast.error("Please Assign Claims Handler.");
      return;
    }
    if (!remarksInModal) {
      toast.error("Please enter remarks");
      return;
    }
    setLoading(true);
    const response = await updateFlag({
      claimId: claimDetailCookie.claimNo,
      flagId: LITIGATION,
      userId: roleDataCookie?.userID,
      remarks: remarksInModal,
      documentId: addedFiles.map((list) => list.id)
    },setLoading);
    setLoading(false);
    toast.success(response);
    getClaimDetails(claimDetailCookie?.claimNo);
    getLitigationDetails();
    setRemarksInModal("");
    setLitigationModal(false);
    setAddedFiles([]);
  };
  const handleModalClose = () => {
    setFlagLitigation(previousFlagLitigation);
    setLitigationModal(false);
    setRemarksInModal("");
    setAddedFiles([]);
  };

  useEffect(()=>{
    let updatedRow = [];
    if(rows?.length) {
      updatedRow = [{
        remarks: rows[0].remarks,
        createdDate: rows[0].createdDate, 
        createdBy: rows[0].createdBy,
        listOfDocDetails: rows[0].documents
      }]
    }
    setFinalLitigationData([...updatedRow, ...litigationList])
  }, [rows, litigationList]) 

  const handleDocumentClick = (docs) => {
    setSelectedDocs(formatDocumentDetails ? formatDocumentDetails(docs) : docs);
    setCurrentIndex(0);
    setShowModal(true);
  };

  return (
    <div>
      {loading ? (
        <LoadingPage kshemaLoader />
      ) : (
        <div>
          <div className="potential">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="flagLitigation"
                checked={flagLitigation}
                onClick={handleFlagLitigation}
                disabled={isLitigationFlagged}
                readOnly
              />
              <label className="form-check-label mb-3" htmlFor="flagLitigation">
                Flag a Litigation
              </label>
            </div>
            {litigationModal && (
              <Modal
                show={litigationModal}
                isOpen={litigationModal}
                centered={true}
                backdrop={"static"}
                className="fraud-modal-width"
              >
                <ModalBody>
                  <div>
                    <label>
                      <h6>
                        Remarks <AsteriskSymbol />
                      </h6>
                    </label>
                  </div>
                  <div>
                    <textarea
                      className="remarksPotential"
                      placeholder="Please enter remarks"
                      value={remarksInModal}
                      onChange={(e) => {
                        const litigationRemarks = e.target.value
                          .replace(REGEX.ALPHANUM_SPACE, "")
                          .slice(0, flagClaimsMaxLength);
                        setRemarksInModal(litigationRemarks);
                      }}
                    ></textarea>
                    <div className="remarks-text-info right">
                      <p>
                        {remarksInModal.length}/{flagClaimsMaxLength}
                      </p>
                    </div>
                    <FileUpload
                      validtype={Litigationvalidtypes}
                      addedFiles={addedFiles}
                      setAddedFiles={setAddedFiles}
                      text={"Upload File"}
                      module="litigation"
                      roleDataCookie={roleDataCookie}
                      doctypeName="litigation"
                      tran_id={claimDetailCookie.claimNo}
                    />
                  </div>
                </ModalBody>
                <ModalFooter className="justify-content-center">
                  <Button variant="outline-danger" onClick={handleModalClose}>
                    Cancel
                  </Button>
                  <Button
                    variant="outline-success"
                    onClick={() => submitLitigation()}
                  >
                    Submit
                  </Button>
                </ModalFooter>
              </Modal>
            )}
          </div>
          <TabComponent
            tabs={filteredTabs}
            activeTab={activeTab}
            handleTabClick={handleTabClick}
          />
        </div>
      )}
      {loading ? (
        <LoadingPage kshemaLoader />
      ) : (
        <div>
          <div>
            {activeTab === "litigation" && (
              <div>
                <div className="d-flex align-items-end justify-content-end mb-3">
                  {/* Only show the Add Remarks & Documents button if in edit mode and not already adding */}
                  {/* TO DO // {(!showRemarksDocs && !flagLitigation) && */}
                  {!showRemarksDocs &&
                    isLitigationFlagged &&
                    editModeOn(functionalities.CLAIM_LITIGATION_SUBMISSION) && (
                      <div
                        className="requestCalc h-auto"
                        onClick={handleRemarksDocsClick}
                      >
                        Add Remarks & Documents
                      </div>
                    )}
                </div>
                {/* Always show existing litigation list */}
                {finalLitigationData && finalLitigationData.length > 0
                  ? finalLitigationData.map((list, index) => (
                      <Accordion className="mb-2" key={index}>
                        <Accordion.Item
                          className="mx-3 border_dark"
                          eventKey={index + 1}
                        >
                          <Accordion.Header>
                            <div className="gis-idCalc">
                              Litigation Remarks - {index + 1}
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="mb-3">
                              <span className="fw-bold d-block">Remarks</span>
                              <span className="d-block">
                                <ViewMoreLess
                                  text={list?.remarks || "--"}
                                  customClassName="w-100 mb-0 text-wrap me-2 d-inline"
                                />
                              </span>
                            </div>
                            <div className="mb-3">
                              <span className="fw-bold d-block">Actioned Date &amp; Time</span>
                              <span className="d-block">
                                {list?.createdDate
                                  ? format(new Date(list?.createdDate), DATE_FORMAT.DD_MM_YYYY_HH_MM)
                                  : "--"}
                              </span>
                            </div>
                            <div className="mb-3">
                              <span className="fw-bold d-block">Actioned By</span>
                              <span className="d-block">
                                {list?.createdBy || "--"}
                              </span>
                            </div>

                            <div className="mb-1">
                              <span className="fw-bold d-block">Documents</span>
                              <span className="d-block">
                                {list?.listOfDocDetails && list?.listOfDocDetails.length > 0 ? (
                                  <button
                                    className="btn btn-link text-primary p-0"
                                    onClick={() => handleDocumentClick(list?.listOfDocDetails)}
                                  >
                                    View Documents ({list?.listOfDocDetails.length})
                                  </button>
                                ) : (
                                  <span className="text-muted">---</span>
                                )}
                              </span>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    ))
                  : // Only show "No data Found" if not currently adding a new litigation AND there are no existing records
                    !showRemarksDocs && <NoDataFound text={"No data Found"} />}
                {showModal && (
                  <DocumentSliderModal
                    show={showModal}
                    onClose={() => setShowModal(false)}
                    documents={selectedDocs}
                    currentIndex={currentIndex}
                    setCurrentIndex={setCurrentIndex}
                  />
                )}
                {/* Show Add Litigation form */}
                {showRemarksDocs && (
                  <Accordion className="mb-2" defaultActiveKey={["0"]}>
                    <Accordion.Item className="mx-3 border_dark" eventKey="0">
                      <Accordion.Header>
                        <div className="gis-idCalc">
                          Add Remarks & Documents
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="remarks-section">
                          Remarks <AsteriskSymbol />
                        </div>
                        <textarea
                          name="remarks"
                          id="remarks"
                          className="w-100 textarea"
                          rows="5"
                          maxLength={flagClaimsMaxLength}
                          onChange={(e) => setRemarks(e.target.value)}
                          value={remarks}
                        ></textarea>
                        <div className="text-end small text-muted">
                          {remarks.length}/{flagClaimsMaxLength} characters
                        </div>
                        <FileUpload
                          validtype={Litigationvalidtypes}
                          addedFiles={addedFiles}
                          setAddedFiles={setAddedFiles}
                          text={"Upload File"}
                          module="litigation"
                          roleDataCookie={roleDataCookie}
                          doctypeName="litigation"
                          tran_id={claimDetailCookie.claimNo}
                        />
                        <div className="button-group">
                          <div
                            className="back_backAccess pointer"
                            onClick={clearRemarksDocs}
                          >
                            Cancel
                          </div>
                          <div
                            className="submit-2Access"
                            onClick={createLitigation}
                          >
                            Submit
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                )}
              </div>
            )}
            {activeTab === "legalExpense" && (
              <div className="mt-4">
                <div className="d-flex align-items-end justify-content-end mb-3">
                  {!showAddLegalExpense &&
                    isLitigationFlagged &&
                    editModeOn(functionalities.CLAIM_LEGAL_EXPENSES_PAGE) && (
                      <div
                        className="requestCalc"
                        onClick={handleAddLegalExpenseClick}
                      >
                        Add Legal Expenses
                      </div>
                    )}
                </div>

                {expenseList && expenseList.length > 0
                  ? expenseList.map((list, index) => (
                      <Accordion className="mb-2" key={index}>
                        <Accordion.Item
                          className="mx-3 border_dark"
                          eventKey={index + 1}
                        >
                          <Accordion.Header>
                            <div className="gis-idCalc">
                              Expense-{index + 1}
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                          <div className="mb-3">
                            <span className="fw-bold d-block">Remarks</span>
                            <span className="d-block text-wrap text-break">
                              <ViewMoreLess
                                text={list?.remarks || "--"}
                                customClassName="w-100 mb-0 text-wrap me-2 d-inline"
                              />
                            </span>
                          </div>
                          <div className="mb-3">
                            <span className="fw-bold d-block">Amount</span>
                            <span className="d-block text-wrap text-break">
                              {typeof list?.amount === "number" || (typeof list?.amount === "string" && list?.amount?.trim() !== "")
                                ? <>₹{list.amount}</>
                                : "--"}
                            </span>
                          </div>
                          <div className="mb-1">
                            <span className="fw-bold d-block">Documents</span>
                            <div className="d-block">
                            {list?.listOfDocDetails && list?.listOfDocDetails?.length > 0 ? (
                              <button
                                className="btn btn-link text-primary p-0"
                                onClick={() => handleDocumentClick(list?.listOfDocDetails)}
                              >
                                View Documents ({list?.listOfDocDetails?.length})
                              </button>
                            ) : (
                              <span className="text-muted">---</span>
                            )}
                            </div>
                          </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    ))
                  : !showAddLegalExpense && (
                      <NoDataFound text={"No data Found"} />
                    )}
                {showModal && (
                  <DocumentSliderModal
                    show={showModal}
                    onClose={() => setShowModal(false)}
                    documents={selectedDocs}
                    currentIndex={currentIndex}
                    setCurrentIndex={setCurrentIndex}
                  />
                )}
                {showAddLegalExpense && (
                  <Accordion className="mb-2" defaultActiveKey={["1"]}>
                    <Accordion.Item className="mx-3 border_dark" eventKey="1">
                      <Accordion.Header>
                        <div className="gis-idCalc"> Legal Expenses</div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="remarks-section">
                          Remarks <AsteriskSymbol />
                        </div>
                        <div className="text-remarks">
                          <textarea
                            name="remarks"
                            id="remarks"
                            className="w-100 textarea"
                            rows="5"
                            maxLength={flagClaimsMaxLength}
                            onChange={(e) => setRemarks(e.target.value)}
                            value={remarks}
                          ></textarea>
                        </div>
                        <div className="text-end small text-muted">
                          {remarks.length}/{flagClaimsMaxLength} characters
                        </div>
                        <div className="mbb-3">
                          <div className="amount-section">
                            <div className="label">
                              {" "}
                              Amount (₹) <AsteriskSymbol />{" "}
                            </div>
                            <input
                              className="form-control input"
                              placeholder="Enter Legal Expenses Amount"
                              id="legalExpenseAmount"
                              onChange={(e) => {
                                let inputValue = e.target.value;
                                inputValue = sanitizeInput(inputValue);
                                if (
                                  (REGEX.DECIMAL_NUMBER_REGEX.test(
                                    inputValue
                                  ) ||
                                    inputValue === "") &&
                                  parseFloat(inputValue) > 0
                                ) {
                                  setLegalExpenseAmount(inputValue);
                                } else if (inputValue === "") {
                                  setLegalExpenseAmount("");
                                }
                              }}
                              value={legalExpenseAmount}
                            />
                          </div>
                          <FileUpload
                            validtype={Litigationvalidtypes}
                            addedFiles={addedFiles}
                            setAddedFiles={setAddedFiles}
                            text={"Upload File"}
                            module="legalExpense"
                            roleDataCookie={roleDataCookie}
                            doctypeName="legalExpense"
                            tran_id={claimDetailCookie.claimNo}
                          />
                        </div>
                        <div className="button-group">
                          <div
                            className="back_backAccess pointer"
                            onClick={clearCreateLegalExpenses}
                          >
                            Cancel
                          </div>
                          <div
                            className="submit-2Access"
                            onClick={handleCreateLegalExpense}
                          >
                            Submit
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Litigation;
